/* eslint-disable import/no-extraneous-dependencies */
import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axiosInstance";

const url = process.env.RSL_BACKEND_URL;
const url_ls = process.env.BACKEND_URL;

/* ---------------- INITIAL STATE ---------------- */
const initialState = {
  isLoading: false,
  error: null,
  rentalBusListNew: [],
};

/* ---------------- SLICE ---------------- */
const slice = createSlice({
  name: "bus",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getValidateReferralCodeSuccess(state, action) {
      state.isLoading = false;
      state.verifyReferralRes = action.payload;
    },
    getSubmitOtherEnquirySuccess(state, action) {
      state.isLoading = false;
      state.enquirySubmitRes = action.payload;
    },
  },
});

/* ---------------- REDUCER ---------------- */
export default slice.reducer;

/* ---------------- ACTIONS ---------------- */
export const {
  startLoading,
  hasError,
  getValidateReferralCodeSuccess,
  getSubmitOtherEnquirySuccess
} = slice.actions;

/* ---------------- THUNK ---------------- */
export function validateReferralCode(filterParam) {
  return async (dispatch) => {
    dispatch(startLoading());

    try {
      const response = await axiosInstance.post(
        `${url}/passenger/validateReferralCode`,
        filterParam
      );

      dispatch(getValidateReferralCodeSuccess(response.data));
    } catch (error) {
      dispatch(getValidateReferralCodeSuccess(error?.response?.data ?? error));
      dispatch(hasError(error));
    }
  };
}

export function submitOtherEnquiry(filterParam) {
  return async (dispatch) => {
    dispatch(startLoading());

    try {
      const response = await axiosInstance.post(
        `${url_ls}/realEstate/submitOtherEnquiry`,
        filterParam
      );

      dispatch(getSubmitOtherEnquirySuccess(response.data));
    } catch (error) {
      dispatch(getSubmitOtherEnquirySuccess(error?.response?.data ?? error));
      dispatch(hasError(error));
    }
  };
}